import React from 'react';
import { X, AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface RemoveMemberModalProps {
  isOpen: boolean;
  onClose: () => void;
  onRemoveFromBrand: () => void;
  onRemoveFromOrganisation: () => void;
  email: string;
  brandName?: string;
}

export const RemoveMemberModal: React.FC<RemoveMemberModalProps> = ({
  isOpen,
  onClose,
  onRemoveFromBrand,
  onRemoveFromOrganisation,
  email,
  brandName,
}) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[60] overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        <div className="fixed inset-0 bg-black bg-opacity-25" onClick={onClose} />

        <div className="relative bg-white rounded-xl border border-black shadow-xl max-w-2xl w-full p-6">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-2 text-red-600">
              <AlertTriangle className="w-5 h-5" />
              <h2 className="text-xl font-semibold">
                {t('teamMembers.removeMember.title')}
              </h2>
            </div>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-500">
              <X className="w-5 h-5" />
            </button>
          </div>

          <div className="space-y-4">
            <p className="text-gray-700">
              {t('teamMembers.removeMember.description')}
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="rounded-lg border border-gray-200 p-3">
                <div className="font-medium">{t('teamMembers.removeMember.brand.title')}</div>
                <p className="text-sm text-gray-600 mt-1">
                  {t('teamMembers.removeMember.brand.desc')}
                </p>
                <button
                  onClick={onRemoveFromBrand}
                  className="mt-3 w-full px-4 py-2 text-sm font-medium bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
                >
                  {t('teamMembers.removeMember.brand.cta')}
                </button>
              </div>

              <div className="rounded-lg border border-red-200 p-3 bg-red-50">
                <div className="font-medium text-red-700">{t('teamMembers.removeMember.org.title')}</div>
                <p className="text-sm text-red-700 mt-1">
                  {t('teamMembers.removeMember.org.desc')}
                </p>
                <button
                  onClick={onRemoveFromOrganisation}
                  className="mt-3 w-full px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700"
                >
                  {t('teamMembers.removeMember.org.cta')}
                </button>
              </div>
            </div>

            <div className="text-xs text-gray-500">
              {email} {brandName ? `• ${brandName}` : ''}
            </div>
          </div>

          <div className="mt-6 flex justify-end">
            <button onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-800">
              {t('common.close')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RemoveMemberModal;


